import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isExpanded: false,
    sidebarCollapsed: false,
};

const layoutExpandSlice = createSlice({
    initialState,
    name: 'LayoutExpand',
    reducers: {
        updateLayOut: (state, action) => {
            state.isExpanded = action.payload.isExpanded;
        },
        setSidebarCollapsed: (state, action) => {
            state.sidebarCollapsed = action.payload;
        },
    }
});

export default layoutExpandSlice;
export const { updateLayOut, setSidebarCollapsed } = layoutExpandSlice.actions;